import {
  GrabIconButton,
  Typography,
  DeleteIconButton,
  Box,
  DELETE_WARNING,
  Grid,
  RichTextReader,
  RichTextEditor,
} from "@compass/core";
import { FormSubQuestion } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import { Input } from "components";
import { Draggable } from "react-beautiful-dnd";

type SurveyQuestionSubQuestionProps = {
  subQuestion: FormSubQuestion;
  index: number;
  selected: boolean | undefined;
  addSubQuestion?: () => void;
  updateSubQuestion?: (value: FormSubQuestion) => void;
};

export const SurveyQuestionSubQuestion = ({
  subQuestion,
  index,
  selected,
  addSubQuestion,
  updateSubQuestion,
}: SurveyQuestionSubQuestionProps) => {
  const [formSubQuestion, setFormSubQuestion] = useState<FormSubQuestion | undefined>(subQuestion);
  const [isHovered, setIsHovered] = useState<boolean>(false);

  useEffect(() => {
    if (updateSubQuestion) updateSubQuestion(formSubQuestion!);
  }, [formSubQuestion]);

  const deleteSubQuestion = (e) => {
    if (window.confirm(DELETE_WARNING)) {
      e.stopPropagation();
      setFormSubQuestion(
        produce((draft) => {
          draft!.deleted = true;
        })
      );
    }
  };

  const grid = 8;

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 1,
    margin: `0 0 ${grid}px 0`,

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  return (
    <Draggable
      key={`${formSubQuestion?.id}:${formSubQuestion?.displayOrder}`}
      draggableId={`subQuestion:${formSubQuestion?.id}:${formSubQuestion?.displayOrder}`}
      index={index || 0}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
        >
          <Box onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <Grid container spacing="sm">
              <Grid item xs={2}>
                <Box>
                  {!selected && <Typography>{formSubQuestion?.label}</Typography>}
                  {selected && (
                    <Input
                      placeholder="Add Label"
                      value={formSubQuestion?.label}
                      onChange={(e) =>
                        setFormSubQuestion(
                          produce((draft) => {
                            draft!.label = e.target.value!;
                          })
                        )
                      }
                    />
                  )}
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Box style={{ minWidth: 300 }}>
                  {!selected && <RichTextReader html={formSubQuestion?.name} />}
                  {selected && (
                    <RichTextEditor
                      justStyle
                      placeholder="Add Sub-Question Answer"
                      // onFocus={() => {
                      //   if (addSubQuestion) addSubQuestion();
                      // }}
                      value={formSubQuestion?.name}
                      onChange={(value) =>
                        setFormSubQuestion(
                          produce((draft) => {
                            draft!.name = value!;
                          })
                        )
                      }
                    />
                  )}
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box {...provided.dragHandleProps}>
                  {selected && isHovered && subQuestion && (
                    <>
                      <GrabIconButton {...provided.dragHandleProps} />
                      <DeleteIconButton
                        onClick={(e) => {
                          deleteSubQuestion(e);
                        }}
                      />
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
      )}
    </Draggable>
  );
};
